import PagedResponse from "@/types/sv-data/PagedResponse";

export interface EventLinksState {
	eventLinkTableResponse: RetrievedEventLinks
	eventLinkListResponse: RetrievedEventLinks
}

export enum EventLinkViews {
	TableView = 0,
	ListView = 1,
}

export interface PaginatedEventLinkInfo extends PagedResponse {
	data: EventLinkInfo[]
}

export interface EventLinkInfo {
	eventId: number,
	eventTitle: string,
	linkedAt: string,
	groupId: number,
	tenantId: number,
	isEventActive: boolean
}

export interface RetrievedEventLinks {
	eventLinks: PaginatedEventLinkInfo,
	noPermissionCount: number;
}
